import { gql } from '@apollo/client';
// Fragments
import { PromocodeFields } from './fragments';

export const GET_PROMO_CODE = gql`
  query GetPromocode($input: GetPromoCodeInput!) {
    getPromocode(input: $input) {
      ...PromocodeFields
    }
  }
  ${PromocodeFields}
`;
